import { useState } from "react";

import React from "react";
import Image from "next/image";
import Header from "@/components/header/Header";
import Successmark from "@/public/svg/success-icon.svg";

import ThailandEnquiry from "@/app/thailand/main-page/utils/EnquiryWizard";
import MaldivesEnquiry from "@/app/maldives/main-page/utils/EnquiryWizard";
import DubaiEnquiry from "@/app/dubai/main-page/utils/EnquiryWizard";
import SingaporeEnquiry from "@/app/singapore/main-page/utils/EnquiryWizard";
import MalaysiaEnquiry from "@/app/malaysia/main-page/utils/EnquiryWizard";
import BaliEnquiry from "@/app/bali/main-page/utils/EnquiryWizard";
import AndamanEnquiry from "@/app/andaman/main-page/utils/EnquiryWizard";
import VietnamEnquiry from "@/app/vietnam/main-page/utils/EnquiryWizard";
import HongKongEnquiry from "@/app/hongkong/main-page/utils/EnquiryWizard";
import AzerbaijanEnquiry from "@/app/azerbaijan/main-page/utils/EnquiryWizard";

import ThailandImage from "@/app/reviews/images/travel-image/thailand.jpg";
import MalDivesImage from "@/app/reviews/images/travel-image/maldives.jpg";
import DubaiImage from "@/app/reviews/images/travel-image/dubai.jpg";
import SingImage from "@/app/reviews/images/travel-image/singapore.jpeg";
import MalayImage from "@/app/reviews/images/travel-image/malaysia.jpg";
import BaliImage from "@/app/reviews/images/travel-image/bali1.jpg";
import AndamanImage from "@/app/reviews/images/travel-image/andaman.png";
import HongkongImage from "@/app/reviews/images/travel-image/hongkong.jpeg";
import VietnamImage from "@/app/reviews/images/travel-image/vietnam.jpg";
import AzerbaijanImage from "@/app/reviews/images/view-more/09.webp";

import ThailandbgImage from "@/public/png/thailand/thailand-three.jpg";
import MalDivesbgImage from "@/app/reviews/images/view-more/maldives.jpg";
import DubaibgImage from "@/app/reviews/images/view-more/dubai.jpg";
import SingbgImage from "@/app/reviews/images/view-more/singapore.jpg";
import MalaybgImage from "@/app/reviews/images/view-more/malaysia.jpg";
import BalibgImage from "@/app/reviews/images/view-more/bali.jpg";
import AndamanbgImage from "@/app/reviews/images/view-more/andaman.jpg";
import HongkongbgImage from "@/app/reviews/images/view-more/hongkong.jpg";
import VietnambgImage from "@/app/reviews/images/view-more/vietnam.jpg";
import AzerbaijanbgImage from "@/app/reviews/images/view-more/azerbaijan.jpg";

import HeroImage from "@/public/png/about-us/about-us.jpg";
import Heading from "@/components/heading/heading";
import "@/styles/home/form.scss";
import "./hero-picture.scss";

interface BannerComponentProps {
    country: string;
    reviewscount: number;
    pathname: string;
}

const BannerComponent: React.FC<BannerComponentProps> = ({
    country,
    reviewscount,
    pathname,
}) => {
    const heroImages: Record<string, any> = {
        Thailand: ThailandbgImage,
        Maldives: MalDivesbgImage,
        Dubai: DubaibgImage,
        Singapore: SingbgImage,
        Malaysia: MalaybgImage,
        Bali: BalibgImage,
        Andaman: AndamanbgImage,
        Vietnam: VietnambgImage,
        HongKong: HongkongbgImage,
        Azerbaijan: AzerbaijanbgImage,
    };

    const ClientImages: Record<string, any> = {
        Thailand: ThailandImage,
        Maldives: MalDivesImage,
        Dubai: DubaiImage,
        Singapore: SingImage,
        Malaysia: MalayImage,
        Bali: BaliImage,
        Andaman: AndamanImage,
        Vietnam: VietnamImage,
        HongKong: HongkongImage,
        Azerbaijan: AzerbaijanImage,
    };

    const Tourpath: Record<string, any> = {
        Thailand: "/thailand",
        Maldives: "/maldives",
        Dubai: "/dubai",
        Singapore: "/singapore",
        Malaysia: "/malaysia",
        Bali: "/bali",
        Andaman: "/andaman",
        Vietnam: "/vietnam",
        HongKong: "/hongkong",
        Azerbaijan: "/azerbaijan",
    };

    const Countrytitle: Record<string, any> = {
        Thailand: "Thailand Travel Tales",
        Maldives: "Maldives Memories",
        Dubai: "Dubai Diaries",
        Singapore: "Singapore Traveller Experiences",
        Malaysia: "Malaysia Customer Experiences",
        Bali: "Bali Vacation Diaries",
        Andaman: "Andaman Traveller Voices",
        Vietnam: "Vietnam Wanderer Tales",
        HongKong: "HongKong Getaway Reviews",
        Azerbaijan: "Azerbaijan Customer Stories",
    };

    const Reviewcount: Record<string, any> = {
        Thailand: "400 Reviews, 2000+ Tours",
        Maldives: "150 Reviews, 750+ Tours",
        Dubai: "100 Reviews, 250+ Tours",
        Singapore: "75 Reviews, 150+ Tours",
        Malaysia: "75 Reviews, 150+ Tours",
        Bali: "150 Reviews, 300+ Tours",
        Andaman: "80 Reviews, 190+ Tours",
        Vietnam: "180 Reviews, 350+ Tours",
        HongKong: "15 Reviews, 50+ Tours",
        Azerbaijan: "5 Reviews, 10+ Tours",
    };

    const PathCount = Reviewcount[country];
    const PathTitle = Countrytitle[country];
    const PathTour = Tourpath[country];
    const MainClients = ClientImages[country] || HeroImage;
    const MainHero = heroImages[country] || HeroImage;

    const [formSubmitStatus, setFormSubmitStatus] = useState(false);

    return (
        <div className="hero-section country-hero overflow-hidden">
            <figure className="image-wrapper">
                <Image
                    loading="lazy"
                    className="hero-image country-img"
                    src={MainHero}
                    alt="hero image"
                />
            </figure>
            <Header />
            <div className="hero-inner container px-4 flex flex-col mx-auto">
                <div className="hero-content grid grid-cols-1 gap-10 lg:gap-4 lg:grid-cols-5 xl:grid-cols-8">
                    <div className="justify-end col-span-1 flex flex-col lg:col-span-3 xl:col-span-5 ">
                        <div className="other text-white md:text-black md:bg-white rounded-lg review-detail flex flex-col gap-4 items-center mx-auto md:ml-0">
                            <Image
                                loading="lazy"
                                className="client-img"
                                src={MainClients}
                                alt="hero image"
                            />
                            <div className="country-review">
                                <div className="detail">
                                    <h2 className="text-xl md:text-xl font-bold py-1 inline-block text-center md:text-left">
                                        {PathTitle}
                                    </h2>
                                    <p className="text-lg text-white md:text-black text-center md:text-left">
                                        {PathCount}
                                    </p>
                                </div>
                                <a href={PathTour}>
                                    <button className="mt-4 px-6 py-2 bg-[#FF4514] text-white rounded-lg font-semibold">
                                        View all {country} tours
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Right Side - Contact Form */}
                    <div className="col-span-1 lg:col-span-2 xl:col-span-3">
                        <div className="enquire-wizard p-6 flex flex-col gap-6">
                            {formSubmitStatus ? (
                                <div className="enquire-wizard p-6 flex flex-col gap-6 justify-center items-center h-380">
                                    <Image
                                        loading="lazy"
                                        src={Successmark}
                                        alt="Successmark"
                                        width={68}
                                        height={68}
                                    />
                                    <h4 className="text-center">Thanks for Submitting the details</h4>
                                    <p className="text-center">
                                        Check email for day-wise itinerary and
                                        estimated pricing. Our travel planner
                                        will contact you in 24hrs.
                                    </p>
                                </div>
                            ) : (
                                <>
                                    <div className="form-title flex flex-col">
                                        <Heading
                                            as="h3"
                                            className="font-yesteryear font-extralight"
                                        >
                                            Your Perfect Holiday Awaits!
                                        </Heading>
                                        <Heading as="h3">
                                            Download Your Itinerary Now!
                                        </Heading>
                                    </div>
                                    {country == "Thailand" ? (
                                        <ThailandEnquiry
                                            setFormSubmitStatus={
                                                setFormSubmitStatus
                                            }
                                            pathname={pathname}
                                        />
                                    ) : country == "Maldives" ? (
                                        <MaldivesEnquiry
                                            setFormSubmitStatus={
                                                setFormSubmitStatus
                                            }
                                            pathname={pathname}
                                        />
                                    ) : country == "Dubai" ? (
                                        <DubaiEnquiry
                                            setFormSubmitStatus={
                                                setFormSubmitStatus
                                            }
                                            pathname={pathname}
                                        />
                                    ) : country == "Singapore" ? (
                                        <SingaporeEnquiry
                                            setFormSubmitStatus={
                                                setFormSubmitStatus
                                            }
                                            pathname={pathname}
                                        />
                                    ) : country == "Malaysia" ? (
                                        <MalaysiaEnquiry
                                            setFormSubmitStatus={
                                                setFormSubmitStatus
                                            }
                                            pathname={pathname}
                                        />
                                    ) : country == "Bali" ? (
                                        <BaliEnquiry
                                            setFormSubmitStatus={
                                                setFormSubmitStatus
                                            }
                                            pathname={pathname}
                                        />
                                    ) : country == "Andaman" ? (
                                        <AndamanEnquiry
                                            setFormSubmitStatus={
                                                setFormSubmitStatus
                                            }
                                            pathname={pathname}
                                        />
                                    ) : country == "Vietnam" ? (
                                        <VietnamEnquiry
                                            setFormSubmitStatus={
                                                setFormSubmitStatus
                                            }
                                            pathname={pathname}
                                        />
                                    ) : country == "HongKong" ? (
                                        <HongKongEnquiry
                                            setFormSubmitStatus={
                                                setFormSubmitStatus
                                            }
                                            pathname={pathname}
                                        />
                                    ) : country == "Azerbaijan" ? (
                                        <AzerbaijanEnquiry
                                            setFormSubmitStatus={
                                                setFormSubmitStatus
                                            }
                                            pathname={pathname}
                                        />
                                    ) : (
                                        ""
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BannerComponent;
